import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";


export class BrokeTheBankPresentation implements SimplePresentation {
    name: string = "BrokeTheBank";

    constructor() {

    }

    shouldRun(): boolean {
        return DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.NORMAL && DevilsCrossRoad.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();
        controller.setSkipCallback();
        tl.add(() => {
            DevilsCrossRoad.keypadPlugin.hide();
            DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(-1);
        });
        tl.add(DevilsCrossRoad.transitionScreenView.showMaxCap());
        tl.add(DevilsCrossRoad.transitionScreenView.enableButton(() => this.onButtonClick(controller)),"<7");
    }

    private onButtonClick(controller: SimplePresentationRunnerController) {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            DevilsCrossRoad.keypadPlugin.show();
            if (DevilsCrossRoad.model.gameData.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN || DevilsCrossRoad.model.gameData.mode === DevilsCrossRoadGameMode.FREESPIN) {
                DevilsCrossRoad.freespinUnlockAreas.resetEyeAnimations();
            }
        });
        if (DevilsCrossRoad.model.gameData.mode === DevilsCrossRoadGameMode.SUPER_FREESPIN || DevilsCrossRoad.model.gameData.mode === DevilsCrossRoadGameMode.FREESPIN) {
            tl.add(DevilsCrossRoad.transitionScreenView.hideOutro());
        }
        tl.add(DevilsCrossRoad.transitionScreenView.hideMaxCap(), "<");
        tl.add(() => controller.finish());

    }

}